var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "blue-grey darken-3", dark: "", dense: "" } },
        [
          _c("span", [_vm._v("Customer Category")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-account")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.custCatList,
          headers: _vm.headers,
          dense: "",
          loading: this.custCatGetting
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }